import FxCustomerRates from '../accounting/fx-customer-rates.js';
import FxCurrencies from '../accounting/fx-currencies.js';
import organizationLocations from '../hr/organization-locations.js';
import organizationPositions from '../hr/organization-positions.js';
import tenantPayrollSettings from '../system/tenant-payroll-settings.js';
import subscriptionInvoices from './subscription-invoices.js';
import subscriptions from './subscriptions.js';
import referrals from './referrals.js';
import reportingRoles from '../hr/team-member-reporting-roles.js';

export default [
    {
        path: '/:organisation/settings',
        name: 'app.settings',
        component: () => import('@/pages/[organisation]/settings.vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
        children: [
            {
                path: 'team',
                component: () => import('@/pages/[organisation]/settings/team.vue'),
                name: 'app.settings.team',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: 'access.system.tenant.edit-company',
                },
            },
            {
                path: 'team/invite',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/[organisation]/settings/invitations/new.vue'),
                name: 'app.settings.team.invite',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: 'access.system.tenant.edit-company',
                },
            },
            {
                path: 'team/add',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/[organisation]/settings/team-members/new.vue'),
                name: 'app.settings.team.add',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: 'access.system.tenant.edit-company',
                },
            },
            {
                path: 'team/:memberId',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/[organisation]/settings/team-members/[id]/edit.vue'),
                name: 'app.settings.team.edit',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: 'access.system.tenant.edit-company',
                },
            },
            {
                path: 'invitations',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/[organisation]/settings/invitations.vue'),
                name: 'app.settings.team.invitations',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: 'access.system.tenant.edit-company',
                },
            },
            {
                path: 'invitations/:invitationId',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/[organisation]/settings/invitations/[id].vue'),
                name: 'app.settings.team.invitations.view',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: 'access.system.tenant.edit-company',
                },
            },
            {
                path: 'organizations/:id',
                name: 'tenant.edit',
                component: () => import(/* webpackChunkName: "tenants" */ '@/pages/[organisation]/settings/organization/edit.vue'),
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: 'access.system.tenant.edit-company',
                },
            },
            {
                path: 'invoice',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/[organisation]/settings/invoice.vue'),
                name: 'app.settings.invoice',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: 'access.system.tenant.edit-company',
                },
            },
            ...FxCustomerRates,
            ...FxCurrencies,
            ...organizationLocations,
            ...organizationPositions,
            ...tenantPayrollSettings,
            ...subscriptionInvoices,
            ...subscriptions,
            ...referrals,
            ...reportingRoles,
            {
                path: 'registered-devices',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/[organisation]/settings/registered-devices.vue'),
                name: 'app.settings.registered-devices',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: '*',
                },
            },
            {
                path: 'api-tokens',
                component: () => import(/* webpackChunkName: "settings" */ '@/pages/[organisation]/settings/api-tokens.vue'),
                name: 'app.settings.api-tokens',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: '*',
                },
            },
        ],
    },
];
